import React from 'react';

import  Petpreform from './Petpreform';
import Specializedinject from './Specializedinject';
import Shorterscrew from './Shorterscrew';
import Choosemold from './Choosemold';
import Beverageinject from './Beverageinject';
import Pettables from './Pettables';
import Optionalfunct from './Optionalfunct';
import Gallonround from './Gallonround';



const Petperforminje = () => {
  return (
    <div>
    < Petpreform/>
<Specializedinject/>
< Shorterscrew/>
<Choosemold/>
<Beverageinject />
      <Pettables/>
      <Optionalfunct/>   
      <Gallonround />  

    </div>
  );
};

export default Petperforminje;
